function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.75 55.06a.9.9 0 01-1.52-.66V43.09a2.37 2.37 0 00-2.14-2.45h-.8a38.82 38.82 0 00-28.72 14A.91.91 0 012 53.93C3 44.71 5.89 37.36 10.64 32c8.24-9.33 19.63-9.8 21.82-9.8h.41a2.19 2.19 0 001.66-.67 2.56 2.56 0 00.7-1.77V7.49a.9.9 0 011.52-.66l24.88 23.46a.9.9 0 010 1.32z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 3.34
});

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+c2hhcmU8L3RpdGxlPjxwYXRoIGQ9Ik0zNi43NSw1NS4wNmEuOS45LDAsMCwxLTEuNTItLjY2VjQzLjA5YTIuMzcsMi4zNywwLDAsMC0yLjE0LTIuNDVsLS44LDBhMzguODIsMzguODIsMCwwLDAtMjguNzIsMTRBLjkxLjkxLDAsMCwxLDIsNTMuOTNDMyw0NC43MSw1Ljg5LDM3LjM2LDEwLjY0LDMyYzguMjQtOS4zMywxOS42My05LjgsMjEuODItOS44aC40MWEyLjE5LDIuMTksMCwwLDAsMS42Ni0uNjcsMi41NiwyLjU2LDAsMCwwLC43LTEuNzdWNy40OWEuOS45LDAsMCwxLDEuNTItLjY2TDYxLjYzLDMwLjI5YS45LjksMCwwLDEsMCwxLjMyWiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIzLjM0Ii8+PC9zdmc+";
export { SvgShare as ReactComponent };